<template>
  <v-card>
    <v-container>
      <v-alert v-if="errorMessages.length !== 0" dense outlined type="error">
        <li
          v-for="(error, index) in errorMessages"
          :key="index"
          class="caption"
        >
          {{ error }}
        </li>
      </v-alert>
      <v-form
        ref="itemForm"
        class="itemForm"
        @submit.prevent="onSubmit"
        @submit="updateItem"
      >
        <slot />
        <div class="p-postEditor__itemFormBtns">
          <v-btn
            class="ml-2"
            small
            tile
            dark
            color="success"
            @click="updateItem"
          >
            <span>保存</span>
          </v-btn>
          <v-btn
            v-if="isSaved"
            class="ml-2"
            small
            tile
            dark
            color="error"
            @click="deleteItem"
          >
            <span>削除</span>
          </v-btn>
          <v-btn
            class="ml-2"
            small
            tile
            dark
            color="yellow darken-2"
            @click="cancelEdit"
          >
            <span>キャンセル</span>
          </v-btn>
        </div>
      </v-form>
    </v-container>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ItemForm',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      errorMessages: []
    }
  },
  computed: {
    ...mapState({
      editingItemable: (state) => state.PostEditor.editingItemable
    }),
    isSaved: function () {
      return this.item.isSaved
    }
  },
  methods: {
    updateItem () {
      if (this.item.variety === 'text') {
        let itemable = Object.assign({}, this.editingItemable)
        if (itemable.content === '') {
          this.errorMessages.push('文字を入力してから保存してください')
          return false
        }
        itemable['content'] = itemable.content.replace(/\r?\n/g, '')
        this.$store.commit('PostEditor/UPDATE_EDITING_ITEMABLE', itemable)
        this.$emit('savetext')
      }

      if (
        this.item.variety === 'product_introduction' &&
        this.editingItemable.tab == 0 &&
        this.editingItemable.images &&
        this.editingItemable.images.length > 6
      ) {
        const payload = {
          color: 'error',
          text: '登録出来る画像は6枚までです'
        }
        this.$store.commit('SystemMessageStore/create', payload)
        return false
      }

      if (!this.$refs.itemForm.validate()) {
        return false
      }

      if (
        ['image', 'banner'].includes(this.item.variety) &&
        !this.editingItemable.imagableId &&
        !this.editingItemable.imageDirectUrl
      ) {
        this.errorMessages.push('必ず画像を選択してください')
        return false
      }

      if (
        this.item.variety === 'character' &&
        !this.editingItemable.characterImageId
      ) {
        this.errorMessages.push('必ずキャラクターを選択してください')
        return false
      }

      if (
        this.item.variety === 'internal_link' &&
        !this.editingItemable.targetPostId
      ) {
        this.errorMessages.push('必ず記事を選択してください')
        return false
      }

      if (
        this.item.variety === 'embedding' &&
        this.editingItemable.url &&
        !this.editingItemable.data
      ) {
        const payload = {
          status: 400,
          message: '必ず「urlを埋込みに変換」してから保存してください。'
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
        return false
      }

      if (
        this.item.variety === 'table_item' &&
        (!Object.keys(this.editingItemable.tableContent).length ||
          this.editingItemable.tableContent['0'].length < 1)
      ) {
        this.errorMessages.push('表を作成してから保存してください')
        return false
      }

      if (
        this.item.variety === 'button' &&
        !this.editingItemable.sizeType
      ) {
        this.errorMessages.push('必ずボタンテンプレートを選択してください')
        return false
      }
      this.$store.commit('PostEditor/END_EDIT_ITEM')
      const payload = Object.assign({}, this.item)
      const itemableAttributes = Object.assign({}, this.editingItemable)
      Object.assign(payload, { itemableAttributes: itemableAttributes })
      this.$store.commit('PostEditor/UPDATE_ITEM', payload)
      this.$store.commit('PostEditor/SET_POST_SAVED_TO_DB', false)
    },
    cancelEdit () {
      if (this.item.variety === 'table_item') {
        this.$emit('cancel')
      }
      if (this.item.variety === 'text') {
        this.$emit('cancel')
      }
      if (!this.isSaved) {
        this.$store.commit('PostEditor/DELETE_ITEM', this.item.uuid)
      } else {
        this.$store.commit('PostEditor/END_EDIT_ITEM')
      }
    },
    deleteItem () {
      this.$store.commit('PostEditor/DELETE_ITEM', this.item.uuid)
      this.$store.commit('PostEditor/SET_POST_SAVED_TO_DB', false)
    }
  }
}
</script>

<style scoped>
.itemForm:hover {
  cursor: default;
}
</style>
